import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GenericToasterService } from 'src/app/core/services/generic-toaster.service';
import { environment } from 'src/environments/environment';
import { DesuscripcionMail } from '../model/DesuscripcionMail';
import { MotivoDesuscripcion } from '../model/MotivoDesuscripcion.model';
import { Observable } from 'rxjs';
import { DesuscripcionTotalParams } from '../model/DesuscripcionTotalParams';
import { MotivoDesuscripcionNotificacion } from '../model/MotivoDesuscripcionNotificacion';

@Injectable({
  providedIn: 'root',
})
export class DesuscripcionDeNotificacionesService {
  constructor(
    private httpClient: HttpClient,
    private genericToasterService: GenericToasterService
  ) { }

  PostDesuscripcionUsuario(data: DesuscripcionMail): Promise<any> {
    return new Promise((resolve) => {
      this.httpClient
        .post<any>(
          `${environment.apiUrl}/DesuscripcionMails/PostDesuscripcionUsuario`,
          data
        )
        .subscribe({
          next: (data: any) => {
            resolve(data);
          },
          error: (err) => {
            this.genericToasterService.pushError('ERROR_APLICACION');
          },
        });
    });
  }


  GetUserData(encriptedData: string): Promise<DesuscripcionMail> {
    return new Promise(
      (resolve) => {
        this.httpClient
          .get<MotivoDesuscripcion[]>(
            `${environment.apiUrl}/DesuscripcionMails/GetUserInfo/Encode/${encriptedData}`,
          )
          .subscribe({
            next: (data: any) => {
              resolve(data);
            },
            error: (err) => {
              this.genericToasterService.pushError('ERROR_APLICACION');
            },
          });
      }
    )
  }

  GetMotivosDesuscripcion(): Promise<MotivoDesuscripcion[]> {
    return new Promise(
      (resolve) => {
        this.httpClient
          .get<MotivoDesuscripcion[]>(
            `${environment.apiUrl}/DesuscripcionMails/GetMotivosDesuscripcion`
          )
          .subscribe({
            next: (data: any) => {
              resolve(data);
            },
            error: (err) => {
              this.genericToasterService.pushError('ERROR_APLICACION');
            },
          });
      }
    )
  }

  PutMotivoDesuscripcion(data: MotivoDesuscripcionNotificacion): Promise<any> {
    return new Promise((resolve) => {
      this.httpClient
        .post<any>(
          `${environment.apiUrl}/DesuscripcionMails/PutMotivoDesuscripcion`,
          data
        )
        .subscribe({
          next: (data: any) => {
            resolve(data);
          },
          error: (err) => {
            this.genericToasterService.pushError('ERROR_APLICACION');
          },
        });
    });
  }

  PostDesuscripcionTotal(data: DesuscripcionTotalParams): Promise<any> {
    return new Promise((resolve) => {
      this.httpClient
        .post<any>(
          `${environment.apiUrl}/DesuscripcionMails/PostDesuscripcionTotal`,
          data
        )
        .subscribe({
          next: (data: any) => {
            resolve(data);
          },
          error: (err) => {
            this.genericToasterService.pushError('ERROR_APLICACION');
          },
        });
    });
  }
}
